import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Result } from "antd";

export default function Error403() {
  const navigate = useNavigate();
  return (
    <Result
      status="403"
      title="403"
      subTitle="No tienes permiso para ver esta seccion."
      extra={
        <Button type="primary" onClick={() => navigate("/app/home")} style={{ backgroundColor: "#f90336", borderColor: "#f90336" }}>
          Ir al inicio
        </Button>
      }
    />
  );
}
